<template>
  <div
    class="flex flex-col w-full h-fit bg-white border border-grays-400 rounded"
  >
    <!-- Intro -->
    <div
      class="flex flex-col md:flex-row w-full h-fit md:items-center pt-[22px] pl-[16px] pr-[20px] md:pr-[36px] mb-[28px]"
    >
      <h3
        class="flex-1 text-xl font-medium text-primary-700 leading-[36px] items-center"
      >
        כרטיס אשראי
      </h3>
      <div class="flex flex-row items-center gap-[5px]">
        <span class="material-symbols-rounded text-light_blue text-base"
          >lock</span
        >
        <p class="text-light_blue text-xs font-medium">
          פרטי האשראי מאובטחים ומוצפנים
        </p>
      </div>
    </div>

    <!-- Cards -->
    <section
      v-for="card in cards"
      :key="card.id"
      class="flex flex-col lg:flex-row justify-between py-[11px] px-[20px] md:px-[60px] border-b border-grays-400"
    >
      <!-- Action part -->
      <div class="flex flex-col lg:flex-row gap-1 lg:gap-2 xl:gap-[120px]">
        <div class="flex w-[fit] items-center">
          <card-brand-icon
            :brand="card.brand"
            size="lg"
            custom-class="hidden md:flex lg:hidden xl:flex"
          />
        </div>
        <div class="flex flex-col lg:flex-row gap-2 lg:gap-[30px]">
          <div class="flex flex-none flex-row gap-2 lg:flex-col lg:gap-0">
            <p class="text-sm font-medium text-grays-600">מספר אשראי</p>
            <p class="text-base font-regular text-grays-900 text-dir-ltr">
              {{ card.save_card }}
            </p>
          </div>
          <div class="flex flex-none flex-row gap-2 lg:flex-col lg:gap-0">
            <p class="text-sm font-medium text-grays-600">תוקף</p>
            <p class="text-base font-regular text-grays-900">
              {{ card.save_tokef }}
            </p>
          </div>
          <div
            v-if="card.save_taz"
            class="flex flex-none flex-row gap-2 lg:flex-col lg:gap-0"
          >
            <p class="text-sm font-medium text-grays-600">תעודת זהות</p>
            <p class="text-base font-regular text-grays-900">
              {{ card.save_taz }}
            </p>
          </div>
        </div>
      </div>

      <!-- Info part -->
      <div
        class="md:flex flex-row justify-start lg:justify-between items-center gap-[20px] lg:gap-[97px]"
      >
        <div
          v-if="card.is_default"
          class="bg-[#0C8D66] text-white text-sm font-medium px-[8px] py-[3px] rounded my-2 lg:my-0 inline-block"
        >
          כרטיס ברירת מחדל
        </div>
        <div v-else>
          <button-text
            class="text-base font-medium pl-0 flex"
            @click="makeThisCardDefault(card.id)"
          >
            <span class="material-symbols-rounded text-base font-medium"
              >credit_card</span
            >
            הפוך כרטיס לברירת מחדל
          </button-text>
        </div>
        <button
          class="block w-full md:w-[28px] md:h-[28px] md:flex justify-center items-center text-left"
        >
          <span
            class="material-symbols-rounded text-grays-800 text-lg"
            @click="deleteCreditCard(card.id)"
            >delete</span
          >
        </button>
      </div>
    </section>

    <!-- Save changes -->
    <div class="flex flex-col items-end py-[20px] px-[16px]">
      <ButtonSecondary @click="addNewCreditCard">
        <span class="material-symbols-rounded text-lg">add_card</span>
        להוסיף כרטיס אשראי
      </ButtonSecondary>
    </div>
  </div>
</template>

<script>
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import ButtonText from "@/components/Global/ButtonText.vue";
import CardBrandIcon from "@/components/Global/CardBrandIcon.vue";

export default {
  name: "AddCreditCard",
  components: { ButtonText, ButtonSecondary, CardBrandIcon },
  props: {
    cards: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["deleteCard", "addNewCreditCard", "updateDefaultCard"],
  methods: {
    async makeThisCardDefault(defaultCardId) {
      try {
        this.$emit("updateDefaultCard", defaultCardId);
      } catch (e) {
        console.error(e);
      }
    },
    async deleteCreditCard(id) {
      try {
        this.$emit("deleteCard", id);
      } catch (e) {
        console.error(e);
      }
    },
    addNewCreditCard() {
      this.$emit("addNewCreditCard");
    },
  },
};
</script>

<style>
.text-dir-ltr {
  direction: ltr;
}
</style>
